import { ChangeDetectionStrategy, ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output, SimpleChanges } from '@angular/core';
import moment from 'moment';
import { AuctionLotTimerItem } from 'src/app/models/dataModels';
import { ITimer } from './itimer';
import { Subscription } from 'rxjs';
import { LocalUtilService } from 'src/app/services/local-util.service';

@Component({
    selector: 'app-timer',
    templateUrl: './timer.component.html',
    styleUrls: ['./timer.component.css'],
    standalone: false,
    changeDetection: ChangeDetectionStrategy.Default
})
export class TimerComponent implements OnInit {


    timeInSeconds: number;
    serverTimeMonitor: Subscription;
    @Input() name: string;
    @Input() dateOfficialEnd: string;
    @Input() dateEndCountdown: string;
    @Input() hourEndCountdown: string;
    @Input() autoStart: boolean = true;
    @Input() showSign: boolean = false;
    @Input() visible: boolean = true;
    @Input() serverTime: string;
    @Input() isClosed = false; 
    @Output() monitorEvent: EventEmitter<AuctionLotTimerItem> = new EventEmitter();

    public timer: ITimer;
    
    private previousDateEndCountdown: string;
    private previousHourEndCountdown: string;
    private previousServerTime: string;

    ngOnChanges(changes: SimpleChanges) {
        // Controlla solo se i valori critici sono cambiati in modo significativo,
        // ad esempio, ignora serverTime se il timer è già in esecuzione
        let needReinit = false;
        if (changes['dateEndCountdown']) {
          const newVal = changes['dateEndCountdown'].currentValue;
          if (this.previousDateEndCountdown !== newVal) {
            needReinit = true;
            this.previousDateEndCountdown = newVal;
          }
        }
        if (changes['hourEndCountdown']) {
          const newVal = changes['hourEndCountdown'].currentValue;
          if (this.previousHourEndCountdown !== newVal) {
            needReinit = true;
            this.previousHourEndCountdown = newVal;
          }
        }
        // Se serverTime viene aggiornato frequentemente, evita di reinizializzare ogni volta
        // oppure controlla solo se il timer non è già in esecuzione:
        //if (changes['serverTime'] && !this.timer?.hasStarted) {
        if (changes['serverTime']) {
          const newVal = changes['serverTime'].currentValue;
          if (this.previousServerTime !== newVal) {
            needReinit = true;
            this.previousServerTime = newVal;
          }
        }
        
        if (needReinit && !this.isClosed) {
          this.stopTimer();
          this.initTimer();
        } else if(this.isClosed) {
            this.stopTimer();
            this.setZeroToTimerAndMakeNotVisible();
        }
     
    }

    constructor(private localUtil: LocalUtilService) {

    }

    setZeroToTimerAndMakeNotVisible() {
        this.timeInSeconds = 0;
        this.visible = false;
    }

    isVisible() {
        return this.visible;
    }

    public ngOnInit() {
      this.stopTimer();
      this.initTimer();
    }
 
    hasFinished() {
        return this.timer.hasFinished;
    }

    hasStarted() {
        return this.timer.hasStarted;
    }

    isInExtraTime() {
        let output = false;
        let extendedLotDateTime = this.dateEndCountdown + ' ' + this.hourEndCountdown;
        if (extendedLotDateTime != this.dateOfficialEnd) {
            output = true;
        }
        return output;
    }
 
    initTimer() {
        //this.stopTimer();
        if(!this.timeInSeconds) { this.timeInSeconds = 0; }
        if (this.dateEndCountdown) {
            //console.log('dentro initTimer(' + this.name + ')');
            let dateSplitted = this.dateEndCountdown.split("/");
            //console.log('serverTime: ' + this.serverTime);
            let nowDate: moment.Moment = moment(this.serverTime, 'DD/MM/YYYY HH:mm:ss');
            let dateTimeEndCountdown = dateSplitted[2] + '-' + dateSplitted[1] + '-' + dateSplitted[0] + 'T' + this.hourEndCountdown + ":00";
            let dateTimeEndCountdownMoment: moment.Moment = moment(dateTimeEndCountdown);
            
            if (dateTimeEndCountdownMoment > nowDate ) {
            let seconds = (dateTimeEndCountdownMoment.toDate().getTime() - nowDate.toDate().getTime()) / 1000;
            this.timeInSeconds = seconds;
            }

            let firstStart = this.timer == undefined ? true: false
            
            this.timer = <ITimer>{
                seconds: this.timeInSeconds,
                runTimer: false,
                hasStarted: false,
                hasFinished: false,
                secondsRemaining: this.timeInSeconds,
                extraTimeNotified: false
            };
    
            this.timer.displayTime = this.getSecondsWithUnitMeasure(this.timer.secondsRemaining);
            
            if (!this.timer.hasStarted && this.autoStart) {
                this.startTimer();
            }
        }
    }

    startTimer() {
        if (!this.timer.hasStarted) {
            //console.log('startTimer(' + this.name + ')');
            this.timer.hasStarted = true;
            this.timer.runTimer = true;
            this.timerIntervalId = setInterval(() => {
                if (!this.timer.runTimer) { 
                    clearInterval(this.timerIntervalId);
                    this.timerIntervalId = null;
                    return; 
                }
                this.timer.secondsRemaining--;
                this.timer.displayTime = this.getSecondsWithUnitMeasure(this.timer.secondsRemaining);
                if (this.timer.secondsRemaining <= 0) {
                    this.timer.hasFinished = true;
                    let outputTimerEmit: AuctionLotTimerItem = new AuctionLotTimerItem();
                    outputTimerEmit.codiceLotto = this.name;
                    outputTimerEmit.isClosed = true;
                    outputTimerEmit.isExtratime = false;
                    this.monitorEvent.emit(outputTimerEmit);
                    this.timer.displayTime = '';
                    clearInterval(this.timerIntervalId);
                    this.timerIntervalId = null;
                }
            }, 1000);
        }
    }
    

    stopTimer() {
        //console.log('dentro stopTimer(' + this.name + ')');
        if (this.timer) {
            this.timer.hasStarted = false;
            this.timer.runTimer = false;
            this.timer.hasFinished = true;
        }
        if (this.timerIntervalId !== null) {
            clearInterval(this.timerIntervalId);
            this.timerIntervalId = null;
        }
    }    
 
    pauseTimer() {
        this.timer.runTimer = false;
    }
 
    resumeTimer() {
        this.startTimer();
    }

    private timerIntervalId: any = null;
 
    timerTick() {
        if (!this.timer.runTimer) { 
            //console.log('first timerTick(' + this.name + ')');
            return; 
        }        
        this.timerIntervalId = setTimeout(() => {
            if (!this.timer.runTimer) { 
                this.timerIntervalId = null; // Reset per consentire il restart
                return; 
            }
            //console.log('timerTick(' + this.name + ') timerTimeoutId: ' + this.timerIntervalId);
            if (!this.timer.runTimer) { return; }
            this.timer.secondsRemaining--;
            this.timer.displayTime = this.getSecondsWithUnitMeasure(this.timer.secondsRemaining);
            if (this.timer.secondsRemaining > 0) {
                //this.timerTick();  // Chiamata ricorsiva non necessaria con setInterval
                if (this.isInExtraTime() && !this.timer.extraTimeNotified) {                    
                    let outputTimerEmit: AuctionLotTimerItem = new AuctionLotTimerItem();
                    outputTimerEmit.codiceLotto = this.name;
                    outputTimerEmit.isClosed = false;
                    outputTimerEmit.isExtratime = true;
                    this.monitorEvent.emit(outputTimerEmit);
                    this.timer.extraTimeNotified = true;
                }
            } else {
                this.timer.hasFinished = true;
                let outputTimerEmit: AuctionLotTimerItem = new AuctionLotTimerItem();
                outputTimerEmit.codiceLotto = this.name;
                outputTimerEmit.isClosed = true;
                outputTimerEmit.isExtratime = false;
                this.monitorEvent.emit(outputTimerEmit);
                this.timer.displayTime = '';
                this.timerIntervalId = null;
            }
        }, 1000);        

    }
    

    getSecondsWithUnitMeasure(inputSeconds: number) {
      let sec_num = parseInt(inputSeconds.toString(), 10);
      let hours   = Math.floor(sec_num / 3600);
      let minutes = Math.floor((sec_num - (hours * 3600)) / 60);
      let seconds = sec_num - (hours * 3600) - (minutes * 60);
      let hoursString = '';
      let minutesString = '';
      let secondsString = '';
      hoursString = ((hours < 10) ? "0" + hours : hours.toString()) + "h";
      minutesString = ((minutes < 10) ? "0" + minutes : minutes.toString()) + "m";
      secondsString = ((seconds < 10) ? "0" + seconds : seconds.toString()) + "s";
      return hoursString + ' : ' + minutesString + ' : ' + secondsString;
  }
    
}
